<template>
  <div class="home">
    <div class="body">
      <div class="top">
        <PayHeader logout-shown />
        <div v-if="profile" class="profile">
          <img :src="profile?.avatar" alt="" class="avatar" />
          <div class="extra-info">
            <div class="name-level">
              <span class="name">{{ profile?.name }}</span>
              <span class="country-level">({{ profile?.country }};Lv.{{
                profile?.pay_level
                }})</span>
            </div>
            <div class="id">ID:{{ profile?.uid }}</div>
          </div>
        </div>
      </div>

      <!-- 是币商展示跳转 -->
      <ul v-if="channels">
        <li v-for="({ expanded = false,icon,items },index) of channels" :key="index">
          <a href="javascript:;" class="heading" @click="expand(index)">
            <img v-if="icon" :src="icon" alt="" />
            <span class="arrow" :class="{ expanded }" />
          </a>
          <ul v-if="expanded">
            <template v-if="items">
              <template v-if="items.length">
                <li v-for="({ name,priceDesc,tags,discount },i) of items" :key="index + '_' + i">
                  <div class="item" @click="submit(channels[index],items[i])" :key="index + '_img_' + i">
                    <!-- <img v-if="i <= 5" :src="getImageURL(i)" alt="" /> -->
                    <img src="../../assets/image/coin.png" alt="" />
                    <h6>{{ name }}</h6>
                    <!-- <span>{{ tags ? JSON.parse(tags)?.vipExp : 0 }} vip Exp</span> -->
                    <p>{{ priceDesc }}</p>
                  </div>
                  <div v-if="discount" class="topScript">
                    <p></p>
                    <p>{{ JSON.parse(discount)?.label }}<br> OFF</p>
                  </div>
                </li>
              </template>
              <li v-else class="empty" />
            </template>
            <li v-else class="loading-wrapper">
              <AccordionLoading />
            </li>
          </ul>
        </li>
      </ul>
      <div v-else class="loading-wrapper">
        <CircleLoading />
      </div>
    </div>

    <PayFooter help-shown />
  </div>
</template>

<script>
import Index from "./index.ts";
export default Index;
</script>

<style lang="scss">
@use "index.scss";
</style>
